import {Component} from '@angular/core';
import {HasBreadcrumb} from './breadcrumbs/breadcrumb';
import {Router} from '@angular/router';
import {BreadcrumbService} from './breadcrumbs/breadcrumb.service';

@Component({
    templateUrl: 'borrower-dashboard.component.html'
})
export class BorrowerDashboardComponent {
    constructor(private router: Router, private breadcrumbService: BreadcrumbService) {
    }

    async onActivate(renderedComponent: Component): Promise<void> {
        await this.notifyBreadcrumbChanged(renderedComponent);
    }

    private async notifyBreadcrumbChanged(renderedComponent: Component) {
        let currentBreadcrumb = null;

        if (renderedComponent['breadcrumb']) {
            const breadcrumbLabel = await (renderedComponent as HasBreadcrumb).breadcrumb();
            const urlTree = this.router.parseUrl(this.router.url);
            currentBreadcrumb = {label: breadcrumbLabel, urlTree: urlTree};
        }

        this.breadcrumbService.notifyChange(currentBreadcrumb);
    }
}